import { useMemo } from 'react'
import { externalRefAtoms, onExternalCanvasDataChangeAtom } from './atoms'
import { useCanvasStore } from './canvas-store'
import type { ExternalCanvasData } from './container'
import type { TextRefTarget } from './data/v1'

export function useExternalCanvasDataActions() {
	const store = useCanvasStore()

	return useMemo(() => {
		function updateExternalField<K extends TextRefTarget>(field: K, value: ExternalCanvasData[K]) {
			store.set(externalRefAtoms[field], value)

			const onChange = store.get(onExternalCanvasDataChangeAtom)
			if (onChange) {
				onChange({ [field]: value })
			}
		}

		return { updateExternalField }
	}, [store])
}
